/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Flex,
  Grid,
  SelectField,
  TextField,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { createOrder } from "../graphql/mutations";
const client = generateClient();
export default function OrderCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    orderType: "",
    linkedId: "",
  };
  const [orderType, setOrderType] = React.useState(initialValues.orderType);
  const [linkedId, setLinkedId] = React.useState(initialValues.linkedId);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setOrderType(initialValues.orderType);
    setLinkedId(initialValues.linkedId);
    setErrors({});
  };
  const validations = {
    orderType: [],
    linkedId: [{ type: "Required" }],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          orderType,
          linkedId,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await client.graphql({
            query: createOrder.replaceAll("__typename", ""),
            variables: {
              input: {
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "OrderCreateForm")}
      {...rest}
    >
      <SelectField
        label="Order type"
        placeholder="Please select an option"
        isDisabled={false}
        value={orderType}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              orderType: value,
              linkedId,
            };
            const result = onChange(modelFields);
            value = result?.orderType ?? value;
          }
          if (errors.orderType?.hasError) {
            runValidationTasks("orderType", value);
          }
          setOrderType(value);
        }}
        onBlur={() => runValidationTasks("orderType", orderType)}
        errorMessage={errors.orderType?.errorMessage}
        hasError={errors.orderType?.hasError}
        {...getOverrideProps(overrides, "orderType")}
      >
        <option
          children="Ad detail"
          value="AdDetail"
          {...getOverrideProps(overrides, "orderTypeoption0")}
        ></option>
      </SelectField>
      <TextField
        label="Linked id"
        isRequired={true}
        isReadOnly={false}
        value={linkedId}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              orderType,
              linkedId: value,
            };
            const result = onChange(modelFields);
            value = result?.linkedId ?? value;
          }
          if (errors.linkedId?.hasError) {
            runValidationTasks("linkedId", value);
          }
          setLinkedId(value);
        }}
        onBlur={() => runValidationTasks("linkedId", linkedId)}
        errorMessage={errors.linkedId?.errorMessage}
        hasError={errors.linkedId?.hasError}
        {...getOverrideProps(overrides, "linkedId")}
      ></TextField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
